import { HeroOptionB4 } from "@/components/hero/HeroOptionB4";

export default function Hero() {
  return <HeroOptionB4 prefix="hero" sectionId="top" testId="hero-section" rings={false} stats={false} minimal />;
}
